export const RESET_RENEWAL_CONFIGS = 'RESET_RENEWAL_CONFIGS';
export const SET_RENEWAL_CONFIGS = 'SET_RENEWAL_CONFIGS';